import { useSessionStore } from "../../../state/src/useSessionStore";

export type BillPayPricingFingerprint = {
  amount: string;
  billerKey: string;
};

/** Stable key for bill pay destination (biller + receive routing). */
export function getBillPayPricingFingerprint(
  currentSendAmount: string | null | undefined,
  billPayBillerSearchResponseStore: unknown,
  selectedBillerInformation: unknown,
): BillPayPricingFingerprint {
  const amount = String(currentSendAmount || "0").replace(/,/g, "");
  const raw = billPayBillerSearchResponseStore as Record<string, unknown> | null | undefined;
  const billerInfo = (raw?.BillerInfo ?? raw?.billerInfo ?? raw) as Record<
    string,
    unknown
  > | null | undefined;
  const item = (billerInfo?.BillerInfos as unknown[])?.[0] ??
    (billerInfo?.billerInfos as unknown[])?.[0] ??
    billerInfo;
  const row = (item ?? {}) as Record<string, unknown>;
  const receiveCode = String(row.ReceiveCode ?? row.receiveCode ?? "");
  const receiveAgentID = String(
    row.ReceiveAgentId ?? row.ReceiveAgentID ?? row.receiveAgentId ?? "",
  );
  const biller = (selectedBillerInformation ?? {}) as Record<string, unknown>;
  const billerId = String(
    biller.BillerId ??
      biller.billerId ??
      biller.BillerName ??
      biller.billerName ??
      "",
  );
  return { amount, billerKey: `${receiveCode}|${receiveAgentID}|${billerId}` };
}

export function clearBillPayAdditionalFieldValues(): void {
  const state = useSessionStore.getState() as {
    setAdditionalFieldValues?: (values: Record<string, unknown>) => void;
  };
  state.setAdditionalFieldValues?.({});
}

/**
 * Clears stored additional-information answers when amount or destination changes.
 * Returns true when values were cleared.
 */
export function invalidateBillPayAdditionalInformationOnPricingChange(
  previous: BillPayPricingFingerprint | null,
  next: BillPayPricingFingerprint,
): boolean {
  const changed =
    previous !== null &&
    (previous.amount !== next.amount || previous.billerKey !== next.billerKey);
  if (changed) {
    clearBillPayAdditionalFieldValues();
  }
  return changed;
}
